import React from 'react';
import { Link } from '@mui/material';
import { orderHrefBuilder } from './utils';

const LinkOrdine = ({ordine, ordineLabel = null, paginaOrdini = null, tab = 0}) => {
    
    if(ordineLabel === null){
        ordineLabel = ordine.codiceordine;        
    }    

    return (
        <Link href={orderHrefBuilder({ordine, paginaOrdini, tab})} variant="body2">
            {ordineLabel}
        </Link>
    )
}

export default LinkOrdine;